import { createSlice } from "@reduxjs/toolkit";
import { page_initial_data } from "../Page/reducer";
import { initialInPageValue, extractInPage } from "./DataExtractors/InPage";

export const initialNavigationState = () => {
    return {
        inPage: initialInPageValue,
    };
};

const navigationSlice = createSlice({
    name: "navigation",
    initialState: initialNavigationState(),
    extraReducers: (builder) => {
        builder.addCase(page_initial_data, (state, action) => {
            state.inPage = extractInPage(action.payload);
        });
    },
});

export default navigationSlice.reducer;
